const Slider = {
  install: (Vue) => {
    Vue.component('Slider', () => {
      return import('./components/index.vue');
    });
  },
};

export default Slider;
